
jQuery(document).ready(function($) {
      
  
    if ( jQuery('.productReviewImages').length ) {
    
		jQuery('.productReviewImages').magnificPopup({
          delegate: 'a', // child items selector, by clicking on it popup will open
          type: 'image',
          gallery:{
            enabled:true
          }
        });
  
    }
	 
 
    jQuery('.productReviewImages').on('click', function() {
	 console.log( jQuery('img', this).src);
	})
    
    
    

	$('.site-credits-link').on('click', function(e) {
      e.preventDefault();
      $('.site-credits').slideToggle();
		$('html, body').animate({ scrollTop: $(document).height() }, 'slow');
    })
      
  
})

//*CHRISTINA CODE*//
document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.add-to-cart-btn');

  buttons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var productId = this.getAttribute('data-product-id');
      addToCart(productId);
    });
  });
});

function addToCart(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    // Here you can handle what happens after adding to cart.
    // For example, redirecting to the cart page:
    window.location.href = '/cart';
  })
  .catch(error => {
    console.error('Error adding item to cart:', error);
  });
}
document.addEventListener('DOMContentLoaded', function() {
  adjustHeroHeight();

  window.addEventListener('resize', adjustHeroHeight);

  function adjustHeroHeight() {
    var heroSection = document.querySelector('.hero-section');
    if (window.innerWidth <= 767) {
      heroSection.style.height = '{{ section.settings.mobile_height }}%';
    } else {
      heroSection.style.height = '{{ section.settings.desktop_height }}%';
    }
  }
});
